import { IGrupoDTO } from "./Grupo.DTO";
import { Nilable } from "@shared/utils";

export interface IPremioDTO {
    id: number;
    countries: string[];
    enabled: boolean;
    image_url: Nilable<string>;
    long_description: string;
    name: string;
    short_description: string;
    stock: Nilable<number>;
    type: string;
    value: number;
    vendors: string[];
    dollar_price: Nilable<number>;
    enabled_for_campaigns: IGrupoDTO[];
    is_automatic: boolean;
    provider: Nilable<string>;
}

export class PremioDTO {
    public id = 0;
    public paises: string[] = [];
    public activo = true;
    public imagenURL: string;
    public descripcionLarga = "";
    public nombre = "";
    public descripcionCorta = "";
    public stock: Nilable<number> = null;
    public tipo = "";
    public value = 0;
    public vendors: string[] = [];
    public precioDolar = 0;
    public activoParaGrupos: IGrupoDTO[] = [];
    public esAutomatico: boolean;
    public proveedor: Nilable<string>;

    constructor(json: Nilable<Partial<IPremioDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPremioDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.countries != null) {
            this.paises = json.countries;
        }
        if (json.enabled != null) {
            this.activo = json.enabled;
        }
        if (json.image_url != null) {
            this.imagenURL = json.image_url;
        }
        if (json.long_description != null) {
            this.descripcionLarga = json.long_description;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        if (json.short_description != null) {
            this.descripcionCorta = json.short_description;
        }
        if (json.stock != null) {
            this.stock = json.stock;
        }
        if (json.type != null) {
            this.tipo = json.type;
        }
        if (json.value != null) {
            this.value = json.value;
        }
        if (json.vendors != null) {
            this.vendors = json.vendors;
        }
        if (json.dollar_price != null) {
            this.precioDolar = json.dollar_price;
        }
        if (json.enabled_for_campaigns != null) {
            this.activoParaGrupos = json.enabled_for_campaigns;
        }
        if (json.is_automatic != null) {
            this.esAutomatico = json.is_automatic;
        }
    }

    public toJSON(): IPremioDTO {
        return {
            id: this.id,
            countries: this.paises,
            enabled: this.activo,
            image_url: this.imagenURL,
            long_description: this.descripcionLarga,
            name: this.nombre,
            short_description: this.descripcionCorta,
            stock: this.stock,
            type: this.tipo,
            value: this.value,
            vendors: this.vendors,
            dollar_price: this.precioDolar,
            enabled_for_campaigns: this.activoParaGrupos,
            is_automatic: this.esAutomatico,
            provider: this.proveedor
        };
    }
}
